import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import {BrowserRouter } from "react-router-dom";
import { ServerAppBasename } from "config/appUrlConfig";
import "styles/styles.scss";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
    <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
		<BrowserRouter basename={ServerAppBasename}>
			<App />
		</BrowserRouter>
    </ThemeProvider>
);